import { jsx } from 'panel';
import { AddEntryRow } from './components/add-row';
import { RowLabelType } from './types';
/**
 * Function component to render a variable row template for any given entry row
 */

const EntryRendererFactory = function EntryRendererFactory(_ref) {
  let {
    entry,
    el
  } = _ref;
  const rowProps = {
    section: el,
    index: entry.index,
    entry: entry.entry
  };
  return entry.template.call(entry, rowProps);
};

export function template() {
  const showLabels = this.attr("row-label-type") !== RowLabelType.None && this.attr("row-limit") !== 1;
  return jsx("div", {
    sel: '.mp-query-entry-section',
    class: {
      'has-labels': showLabels,
      'is-empty': this.helpers.getEntries().length === 0,
      'is-draggable': this.attr("row-draggable"),
      'for-new-metrics-mode': true
    }
  }, this.getRows(true).map(entry => jsx(EntryRendererFactory, {
    entry: entry,
    el: this
  })), this.helpers.canAddRow() && !this.attr("disable-add-entry") && jsx(AddEntryRow, {
    el: this
  }));
}